// extracted by mini-css-extract-plugin
export default {"header-main":"header_header-main__SpbsD"};